import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom'
import { useStateIfMounted } from 'use-state-if-mounted'
const { useState, useEffect, useRef } = React;
import { Paper, Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import estilos from './TablaProducto.module.css'
import { v4 as uuidv4 } from 'uuid';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    height:550,
    bgcolor: 'background.paper',
    border: 'px solid #000',
    boxShadow: 24,
    p: 4,
    color: 'black',
    'overflowY': 'scroll',
};
const ModalDetalleInstalaciones = (props) => {

    let texto = props.texto
    const { api = undefined } = props
    const { VerModalDetalle = undefined } = api
    const datosRows = props.api.dataDetalle.fc_36_dataelemento
    let rows = []
    for(const i in datosRows){
        let {...row} = datosRows[i]
        row.id = uuidv4()
        rows.push(row)
    }
    /******Modal */
    const [openModal, setOpenModal] = React.useState(true);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')

    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
        VerModalDetalle(false)
        //resetValores({ validacion: false, texto: '' })
    }
    let columns = [
        {
            field: 'elemento', headerName: 'Elemento', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 250,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row?.elemento?.nombreelemento}`} arrow>
                        <label>{`${params.row?.elemento?.nombreelemento} `}</label>
                    </Tooltip>
                </div>
            )
        },

        {
            field: 'cantidad', headerName: 'Cantidad', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 150,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.cantidad}`} arrow>
                        <label>{`${params.row.cantidad} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'descripcion', headerName: 'Descripción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 250,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.descripcion}`} arrow>
                        <label>{`${params.row.descripcion} `}</label>
                    </Tooltip>
                </div>
            )
        },
    ]
    return (
        <div>
            <Modal open={true} onClose={handleCloseModal} aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description" hideBackdrop={true} >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "black", textAlign: 'center' }}>
                        Descripción de la instalación
                    </Typography>
                    <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} style={{ color: "black", textAlign: 'center' }}>
                        <Fragment>
                            <div className='row justify-content-center'>
                                <div className='col-12'>
                                    <div style={{ height: (130 + (rows?.length * 50)), width: '90%', color: 'black', marginLeft: '10%' }}>
                                        <DataGrid
                                            rows={rows}
                                            columns={columns}
                                            sx={{
                                                boxShadow: 0,
                                                color: 'black',
                                                border: 0,
                                                '& .MuiDataGrid-cell': {
                                                    display: 'block',
                                                    position: 'relative',
                                                    textAlign: 'center',
                                                },
                                            }}
                                        />
                                    </div><br />
                                </div>
                            </div>
                        </Fragment>
                    </Typography>
                    <br />
                    <div className='text-center'>
                        <button className={`btn btn-success`} type='button' style={{ width: '50%' }} onClick={() => handleCloseModal()}>Cerrar</button>
                    </div>
                </Box>
            </Modal>
        </div>
    )
};

export default withRouter(ModalDetalleInstalaciones)
